const DEFAULT_AUTH_CONTINUE_PATH = '/dash';

const TRUSTED_APP_ORIGINS = [
  'https://adulab.app',
  'https://adu-lab-uat.web.app',
];

function getBrowserOrigin() {
  if (typeof window !== 'undefined' && window.location?.origin) {
    return window.location.origin;
  }
  return TRUSTED_APP_ORIGINS[1];
}

function toSafeAppPath(rawContinueUrl, currentOrigin, allowedOrigins) {
  if (typeof rawContinueUrl !== 'string') return null;

  const trimmed = rawContinueUrl.trim();
  if (!trimmed) return null;
  if (trimmed.startsWith('//') || trimmed.startsWith('/\\')) return null;

  let parsed;
  try {
    parsed = new URL(trimmed, currentOrigin);
  } catch {
    return null;
  }

  if (!['http:', 'https:'].includes(parsed.protocol)) return null;

  const isRelativePath = trimmed.startsWith('/') && !trimmed.startsWith('//');
  if (!isRelativePath && !allowedOrigins.has(parsed.origin)) return null;

  const path = `${parsed.pathname}${parsed.search}${parsed.hash}`;
  return path.startsWith('/') ? path : null;
}

export function resolveAuthContinuePath(rawContinueUrl, options = {}) {
  const currentOrigin = options.currentOrigin || getBrowserOrigin();
  const allowedOrigins = new Set([
    currentOrigin,
    ...TRUSTED_APP_ORIGINS,
    ...(options.allowedOrigins || []),
  ]);
  const fallbackPath = options.fallbackPath === null
    ? null
    : toSafeAppPath(options.fallbackPath || DEFAULT_AUTH_CONTINUE_PATH, currentOrigin, allowedOrigins) || DEFAULT_AUTH_CONTINUE_PATH;

  return toSafeAppPath(rawContinueUrl, currentOrigin, allowedOrigins) || fallbackPath;
}

export function buildRouteWithContinueUrl(routePath, rawContinueUrl, options = {}) {
  const continuePath = resolveAuthContinuePath(rawContinueUrl, {
    ...options,
    fallbackPath: options.fallbackPath ?? null,
  });

  if (!continuePath) return routePath;

  const separator = routePath.includes('?') ? '&' : '?';
  return `${routePath}${separator}continueUrl=${encodeURIComponent(continuePath)}`;
}

export function buildCurrentLocationPath(location) {
  if (!location) return DEFAULT_AUTH_CONTINUE_PATH;
  return `${location.pathname || '/'}${location.search || ''}${location.hash || ''}`;
}
